import {
  debounce,
  renderTemplate,
  optionTemplate,
  prepareApiData,
} from '../helpers/helpers';

/* eslint-disable func-names */
/* eslint-disable no-undef */
const teamFilter = () => {
  (function ($) {
    // DOM elements
    const $form = $('.js-team-filter');
    const $nameInput = $('.js-team-filter-name');
    const $serviceInput = $('.js-team-filter-service');
    const $locationInput = $('.js-team-filter-location');
    const $resetButton = $('.js-team-filter-reset');
    const $results = $('.js-team-filter-results');
    const $resultHeading = $('.js-team-filter-heading');
    const urlParams = new URLSearchParams(window.location.search);
    const serviceId = urlParams.get('service');

    const languageCode = $('html').attr('lang') || 'en';
    const defaultUrl = `/api/search/team-members?language=${languageCode}`;

    // api data
    let users = false;
    let usersService = false;
    let services = false;
    let locations = false;

    // Don't execute if the section doesn't exist on the page
    if (!$results.length) {
      return;
    }

    $('body,html').animate(
      { scrollTop: $form.offset().top - 50 }, 600,
    );

    const prepareDataForTemplate = (data) => {
      const ret = Object.assign({}, data);
      const phoneData = {
        phone_number: data.phone_number,
        full_name: data.full_name,
      };

      if (Array.isArray(data.phone_number)) {
        ret.phone_number = data.phone_number.map((item, index) => renderTemplate(
          'team-filter-phone-template',
          {
            phone_number: item,
            full_name: `${data.full_name} ${index + 1}`,
          },
        )).join('');
      } else {
        ret.phone_number = renderTemplate('team-filter-phone-template', phoneData);
      }
      ret.accreditations = data.accreditations || '';
      if ($('html').attr('lang') === 'zh-hans') {
        ret.path = `/cn${data.path}`;
      }

      ret.recent_contact = ret.recent ? '<div class="c-team-card__recent">Recent contact</div>' : '';

      return ret;
    };

    /**
     * Populate the results div with filtered users
     * @param {array} data array of the results of the search
     */
    const setResults = (data, heading = ($('html').attr('lang') === 'zh-hans' ? '全球管理团队' : 'Global Leadership Team')) => {
      let html = data.map(item => renderTemplate('team-filter-template', prepareDataForTemplate(item))).join('');
      if (html === '') {
        html = '<div class="c-team-filter__message">&mdash; No results found &mdash;</div>';
      }
      $resultHeading.text(heading);
      $results.html(html);
    };
    if (serviceId !== '') {
      $.ajax({
        url: `${defaultUrl}&service_id=${serviceId}`,
        dataType: 'json',
        success(response) {
          const data = prepareApiData(response);
          usersService = data;
        },
      });
    }
    // Load all users, services and locations
    $.when(
      $.ajax({
        url: defaultUrl,
        dataType: 'json',
        success(response) {
          const data = prepareApiData(response);
          users = data;
        },
      }),
      $.ajax({
        url: `/api/get/meet-team/filters?language=${languageCode}`,
        dataType: 'json',
        success(response) {
          const servicesData = Object.entries(response.services).sort((a, b) => {
            // ensure 'Service' appears first
            if (a[0] === '') {
              return -1;
            }
            if (b[0] === '') {
              return 1;
            }

            // then 'Global Leadership Team'
            if (Number(a[0]) < 0) {
              if (b[0] !== '') {
                return -1;
              }
              return 0;
            }
            if (Number(b[0]) < 0) {
              if (a[0] !== '') {
                return 1;
              }
              return 0;
            }

            // then the rest in alphabetical order
            return a[1].toLowerCase() < b[1].toLowerCase() ? -1 : 1;
          }).map(item => ({ id: item[0], name: item[1] }));

          const locationsData = Object.entries(response.locations).sort((a, b) => {
            // make 'Location' first
            if (a[0] === '') {
              return -1;
            }
            if (b[0] === '') {
              return 1;
            }

            // then the rest in alphabetical order
            return a[1].toLowerCase() < b[1].toLowerCase() ? -1 : 1;
          }).filter(item => Number(item[0]) >= 0).map(item => ({ id: item[0], name: item[1] }));

          ({ services, locations } = response);

          $serviceInput.append(servicesData.map(item => optionTemplate(item)).join(''));
          $locationInput.append(locationsData.map(item => optionTemplate(item)).join(''));
        },
      }),
    ).then(
      () => {
        if (serviceId !== '' && usersService.length > 0) {
          $serviceInput.val(serviceId);
          setResults(usersService, services[serviceId]);
        } else {
          setResults(users);
        }
      },
    );

    // prevent the form refreshing when enter is pressed
    $form.on('submit', (e) => {
      e.preventDefault();
    });

    // Clear all results
    $resetButton.on('click', () => {
      setResults(users);
    });

    // Update the results when 3 characters or more are written
    $nameInput.on('input', debounce(300, (e) => {
      if (!users || !services || !locations) return;

      const { value } = e.currentTarget;
      const valueLower = value.replace(/[^A-z ]/g, '');

      $serviceInput.val('');
      $locationInput.val('');

      // show default results when there is no input
      if (value === '') {
        setResults(users);
        return;
      }

      // don't perform search on fewer than 3 character
      if (value.length < 3) {
        return;
      }

      // show loading spinner
      $results.html('<div class="c-team-filter__loader"></div>');

      $.ajax({
        url: `${defaultUrl}&name=${valueLower}`,
        dataType: 'json',
        success(response) {
          const data = prepareApiData(response);
          setResults(data, `Name search: ${value}`);
        },
      });
    }));

    // Update service filter. Clear other filters
    $serviceInput.on('change', debounce(300, (e) => {
      if (!users || !services || !locations) return;

      const { value } = e.currentTarget;

      $nameInput.val('');
      $locationInput.val('');

      if (value === '') {
        setResults(users);
        return;
      }

      // show loading spinner
      $results.html('<div class="c-team-filter__loader"></div>');

      $.ajax({
        url: `${defaultUrl}&service_id=${value}`,
        dataType: 'json',
        success(response) {
          const data = prepareApiData(response);
          setResults(data, services[value]);
        },
      });
    }));

    // Update location filter. Clear other filters
    $locationInput.on('change', debounce(300, (e) => {
      if (!users || !services || !locations) return;

      const { value } = e.currentTarget;

      $nameInput.val('');
      $serviceInput.val('');

      if (value === '') {
        setResults(users);
        return;
      }

      // show loading spinner
      $results.html('<div class="c-team-filter__loader"></div>');

      $.ajax({
        url: `${defaultUrl}&location_id=${value}`,
        dataType: 'json',
        success(response) {
          const data = prepareApiData(response);
          setResults(data, locations[value]);
        },
      });
    }));
  }(jQuery));
};

export default teamFilter;
